addEventListener('DOMContentLoaded', async () => {

    if(!window.location.pathname.includes('/products/'))
        return;

    await pdpLoad();

    async function pdpLoad() {

        const swatchContainer = document.querySelectorAll('.selector-wrapper--color');

        swatchContainer.forEach(async (container) => {
            const itemNumber = container.dataset.itemNumber;
            const currentValue = container.dataset.currentValue;
            const radioInput = container.querySelector('.radio__inputs--swatch');
            const data = await getColorSwatches(itemNumber);

            console.log('data', data);

            if (!!!data || data.length === 0)
                return;

            radioInput.classList.add('product__grid__info')

            data.forEach((item) => {
                const dataSwatchConteiner = item.querySelector('[data-swatch]');
                const dataSwatch = dataSwatchConteiner?.dataset.swatch;

                if (dataSwatch === currentValue)
                    return;

                radioInput.appendChild(item);
            })
        });
    }

    async function getColorSwatches(itemNumber) {
        try {
            const response = await fetch(`/collections/all/${itemNumber}`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const radioSwatch = doc.querySelectorAll('#product-grid-collection radio-swatch');

            return [...radioSwatch];
        } catch (error) {
            console.error('Error fetching color swatch:', error);
        }
    }
});
